<h1 mat-dialog-title>
  Add to Team Models
</h1>

<div mat-dialog-content class="dialog">

  <form [formGroup]="form" (submit)="handleSubmit()">

    <!-- permission -->
    <app-form-field theme="light" label="Permissions" class="mt-2 mb-2">

        <mat-radio-group class="dialog__radio-group text-12 mt-2" formControlName="groupEditEnabled">
          <mat-radio-button value="false" class="mb-2">Team - View Only</mat-radio-button>
          <mat-radio-button value="true">Team - View & Edit</mat-radio-button>
        </mat-radio-group>

    </app-form-field>

    <!-- collections -->
    <app-form-field *ngIf="(collections$ | async)?.length" label="Collection (Optional)" theme="light" class="mb-2">

      <select class="input" formControlName="collectionId">
          <option [value]="null">--</option>
          <option *ngFor="let collection of collections$ | async" [value]="collection.collection_id">
            {{ collection.collection_name }}
          </option>
        </select>

    </app-form-field>

  </form>
  
</div>

<div mat-dialog-actions class="pt-2">
  <button app-button buttonTheme="light" [mat-dialog-close] type="button" class="mr-2">Cancel</button>
  <button app-button buttonType="primary" cdkFocusInitial (click)="handleSubmit()" [disabled]="copying$ | async">
    <!-- Copying -->
    <ng-container *ngIf="(copying$ | async)">
      <app-spinner size="small" class="mr-1" render="inline"></app-spinner>
      Adding
    </ng-container>

    <!-- Copy -->
    <ng-container *ngIf="!(copying$ | async)">
      Add
    </ng-container>
  </button>
</div>